var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import '../src/assets/css/index.css';
import AuthenticatedMenu from './AuthenticatedMenu';
import UnauthenticatedMenu from './UnauthenticatedMenu';

var NavMenu = function (_React$Component) {
  _inherits(NavMenu, _React$Component);

  function NavMenu(props) {
    _classCallCheck(this, NavMenu);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onToggleNavMenu = function () {
      _this.setState({
        navMenuOpen: !_this.state.navMenuOpen
      });
    };

    _this.onNavigate = function () {
      _this.setState({
        navMenuOpen: false,
        megaMenuOpen: false,
        productsMouseOut: true,
        menuMouseOut: true
      });
    };

    _this.onProductsMouseOver = function () {
      _this.setState({
        productsMouseOut: false
      });

      setTimeout(function () {
        if (this.state.productsMouseOut === false) {
          this.setState({
            megaMenuOpen: true
          });
        }
      }.bind(_this), 300);
    };

    _this.onMenuMouseOver = function () {
      _this.setState({
        menuMouseOut: false
      });
    };

    _this.onProductsMouseLeave = function () {
      _this.setState({
        productsMouseOut: true
      });
    };

    _this.onMenuMouseLeave = function () {
      _this.setState({
        menuMouseOut: true
      });

      setTimeout(function () {
        if (this.state.menuMouseOut === true) {
          this.setState({
            megaMenuOpen: false
          });
        }
      }.bind(_this), 300);
    };

    _this.state = {
      navMenuOpen: false,
      megaMenuOpen: false,
      productsMouseOut: true,
      menuMouseOut: true
    };
    return _this;
  }

  NavMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.pathname !== prevProps.pathname) {
      this.setState({
        navMenuOpen: false,
        megaMenuOpen: false
      });
    }
  };

  NavMenu.prototype.render = function render() {
    var authUser = this.props.authUser;
    return authUser && authUser.id ? React.createElement('div', null, React.createElement(AuthenticatedMenu, _extends({}, this.props, this.state, {
      onToggleNavMenu: this.onToggleNavMenu,
      onNavigate: this.onNavigate,
      onMenuMouseOver: this.onMenuMouseOver,
      onMenuMouseLeave: this.onMenuMouseLeave
    }))) : React.createElement('div', null, React.createElement(UnauthenticatedMenu, _extends({}, this.props, this.state, {
      onToggleNavMenu: this.onToggleNavMenu,
      onNavigate: this.onNavigate
    })));
  };

  return NavMenu;
}(React.Component);

export default NavMenu;